import { FETCH_KEY_REMOVE_AS_FAVOURITE, FETCH_KEY_SET_AS_FAVOURITE } from './constants';

export const fetchKeySetAsFavourite = (id) => `${FETCH_KEY_SET_AS_FAVOURITE}.${id}`;
export const fetchKeyRemoveAsFavourite = (id) => `${FETCH_KEY_REMOVE_AS_FAVOURITE}.${id}`;
